import BaseSubscriptionModal from 'app/components/subscriptionModals/BaseSubscriptionModal';
import Benefits from 'app/components/subscriptionModals/Benefits';
import insightsIcon from 'app/images/insightsModalGreet.svg';
import { FC } from 'react';
import { SUBSCRIPTION_MODAL_BENEFITS } from './subscriptionModalBenefits';
import SubscriptionExpiredButtons from './SubscriptionExpiredButtons';
import SubscriptionExpiredFooter from './SubscriptionExpiredFooter';
import { useTranslation, Trans } from 'react-i18next';

type Props = {
  open: boolean;
};

const InsightsTrialExpired: FC<Props> = ({ open }) => {
  const { t } = useTranslation();

  return (
    <BaseSubscriptionModal
      open={open}
      title={
        <div className="tw-text-xl tw-font-medium">
          <Trans
            i18nKey="insights.trialExpired.title"
            components={{ 1: <strong />, 3: <strong /> }}
          />
        </div>
      }
      image={<img src={insightsIcon} alt="Analytics icon" />}
      buttons={
        <SubscriptionExpiredButtons
          primaryText={t('insights.trialExpired.purchaseButton')}
        />
      }
      benefits={
        <Benefits
          title={t('insights.trialExpired.benefitsTitle')}
          lists={SUBSCRIPTION_MODAL_BENEFITS.insights}
        />
      }
      footer={
        <SubscriptionExpiredFooter
          text={t('insights.trialExpired.footerText')}
        />
      }
    />
  );
};

export default InsightsTrialExpired;
